'use strict';

const { modelInternalTransfer } = require('../../../datatypes');
const { appendFilter } = require('../../../queries');
const addModelInternalTransfersQueries = require('../../../queries/configs/ModelInternalTransfers');

function ModelInternalTransfers({ client, fspId, payerId }) {

  return {
    returnModel: {
      name: 'modelinternaltransfer',
      model: modelInternalTransfer,
    },
    baseUrl: `/fsps/${fspId}/payers/${payerId}/modelinternaltransfers`,
    queriesFilter: appendFilter('payerId', payerId),

    create: function create(data, queryParams, cb) {
      return client.executeRequest('POST', this.baseUrl, {
        data,
        queryParams,
        cb,
        returnModel: this.returnModel,
      });
    },
  };

}

module.exports = addModelInternalTransfersQueries(ModelInternalTransfers);
